import {Injectable} from '@angular/core';
import {HttpCommonService} from "./http-common.service";
import {Observable} from "rxjs/Observable";

/**
 * 省市区三级级联
 */
@Injectable()
export class ThreeCascadeService {


  constructor(private http: HttpCommonService) {
  }

  /**
   * 获取省
   * @returns {Observable<any>}
   */
  getProvinces(): Observable<any> {
    return this.http.get('/user/center/xhsRest/common/getProvinces');
  }

  /**
   * 获取市
   * @returns {Observable<any>}
   */
  getCities(provinceId: any): Observable<any> {
    return this.http.get('/user/center/xhsRest/common/getCitys', {provinceId: provinceId});
  }

  /**
   * 获取区
   * @returns {Observable<any>}
   */
  getDistricts(cityId: any): Observable<any> {
    return this.http.get('/user/center/xhsRest/common/getDistricts', {cityId: cityId});
  }

  /**
   * @returns {Observable<any>}
   */
  getCityPayCode(id: any): Observable<any> {
    return this.http.get('/user/center/xhsRest/common/getCityPayCode', {id: id});
  }

  /**
   * 获取省 -- 城市入驻
   * @returns {Observable<any>}
   */
  getCityProvinces(): Observable<any> {
    return this.http.get('/city/credit/CityApply/getCityProvinces');
  }

  /**
   * 获取市 -- 城市入驻
   * @returns {Observable<any>}
   */
  getCitys(parentAreaId: any): Observable<any> {
    return this.http.get('/city/credit/CityApply/getCitys', {parentAreaId: parentAreaId});
  }
}





// WEBPACK FOOTER //
// E:/java/gd-project/credit-gd-web/src/app/services/three-cascade.service.ts